import React, { useEffect, useState } from "react"

import {
  Card,
  CardBody,
  Col,
  Form,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import { Link } from "react-router-dom"
import FormNewProperty from "./FormNewProperty"
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux"

import { modalPropertyShow, addNewProperty as onAddNewProperty, updateProperty as onUpdateProperty, setProperty, setPropertySaved, setUploadImageSuccess } from "store/actions";
import FormUploadImages from "./FormUploadImages"

const FormPropertyWizard = props => {

  const dispatch = useDispatch();

  const { handleImagesWithOutOpload, typeEdition, toggleModalAddProperty } = props

  const [activeTab, setactiveTab] = useState(1)  

  const [passedSteps, setPassedSteps] = useState([1])

  const { propertySaved, property } = useSelector(state => ({
        propertySaved: state.PropertyReducer.propertySaved,
        property: state.PropertyReducer.property
    }));

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 2) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  const toggleTabBack = () => {
    if((activeTab - 1) === 1) {
      dispatch(setPropertySaved(false))
    }
    toggleTab(activeTab - 1);
  }
  const [isEdit, setIsEdit] = useState(props?.isEdit);
    const [propertyL, setPropertyL] = useState(props.property);  

    const validation = useFormik ({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            concept: (propertyL && propertyL.concept) || "",
            area: (propertyL && propertyL.area_id) || "",
            description: (propertyL && propertyL.description) || "",
            active: (propertyL && propertyL.active) || "",
            location: (propertyL && propertyL.location) || "",
            physical_condition: (propertyL && propertyL.physical_condition) || "",
            observations: (propertyL && propertyL.observations) || "",
            document: (propertyL && propertyL.document) || "",
            document_other: (propertyL && propertyL.document_other) || "",
            num_document: (propertyL && propertyL.num_document) || "",
            value: (propertyL && propertyL.value) || "",
            name_guardian: (propertyL && propertyL.name_guardian) || "",
            trademark: (propertyL && propertyL.trademark) || "",
            serial_number: (propertyL && propertyL.serial_number) || "",
            car_registration_number: (propertyL && propertyL.car_registration_number) || "",
            quantity: (propertyL && propertyL.quantity) || "",
            type_property: (propertyL && propertyL.cat_type_property_id) || "",
            type_property3: (propertyL && propertyL.cat_type_property_id_3) || "",
            active: (propertyL && propertyL.active) || true,
            justification_discontinuation: (propertyL && propertyL.justification_discontinuation) || "",
        },
        validationSchema: Yup.object({
            type_property: Yup.string().required("El tipo de propiedad es requerido"),
            type_property3: Yup.string().required("El rubro es requerido"),
            concept: Yup.string().required("El concepto es requerido"),
            description: Yup.string().required("La descripción es requerido"),
            quantity: Yup.string().required("La cantidad es requerida"),
            value: Yup.string().required("El valor es requerido"),
            document: Yup.string().required("El documento es requerido"),
            document_other: Yup.string().when('document', {
                is: 'OTROS',
                then: () => Yup.string().required("El documento es requerido"),
                otherwise: () => Yup.string()
            }),
            car_registration_number: Yup.string().when('type_property3', {
                is: (val) => ['36', '37', '38', '42', '43'].includes(val),
                then: () => Yup.string().required("La placa es requerida"),
                otherwise: () => Yup.string()
            }),
            justification_discontinuation: typeEdition === "Discontinued" 
                ? Yup.string().required("Ingresa la justificación de baja")
                : Yup.string(),
            location: Yup.string().required("La ubicación es requerida"),
            physical_condition: Yup.string().required("La condición física es requerida"),   
            name_guardian: Yup.string().required("El nombre del custodio es requerido"),
            area: Yup.string().required("El area de la propiedad es requerido"),        
            //active: Yup.boolean().equals(isEdit).required("*"),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                const updateProperty = {
                    id: property ? property?.id : null,
                    concept: values["concept"],
                    type_property3: values["type_property3"],
                    document_other: values["document_other"],
                    description: values["description"],
                    area: values["area"],
                    location: values["location"],
                    utility: values["utility"],
                    physical_condition: values["physical_condition"],
                    observations: values["observations"],
                    document: values["document"],
                    num_document: values["num_document"],
                    value: values["value"],
                    record: values["record"],
                    name_guardian: values["name_guardian"],
                    trademark: values["trademark"],
                    serial_number: values["serial_number"],
                    car_registration_number: values["car_registration_number"],
                    quantity: values["quantity"],
                    type_property: values["type_property"],
                    typeEdition: typeEdition,
                    justification_discontinuation: values["justification_discontinuation"],
                };
                dispatch(onUpdateProperty(updateProperty));
                //validation.resetForm();
            } else {
                const newProperty = {
                    id: property ? property?.id : null,
                    concept: values["concept"],
                    type_property3: values["type_property3"],
                    document_other: values["document_other"],
                    description: values["description"],
                    area: values["area"],
                    location: values["location"],
                    utility: values["utility"],
                    physical_condition: values["physical_condition"],
                    observations: values["observations"],
                    document: values["document"],
                    num_document: values["num_document"],
                    value: values["value"],
                    record: values["record"],
                    name_guardian: values["name_guardian"],
                    trademark: values["trademark"],
                    serial_number: values["serial_number"],
                    car_registration_number: values["car_registration_number"],
                    quantity: values["quantity"],
                    type_property: values["type_property"],

                };
                dispatch(onAddNewProperty(newProperty));
                //validation.resetForm();
            }
        }
    });

    const handleCheckChange = (e) => {
        console.log(e.target.value)
        setPropertyL(prev => ({
            ...prev,
            active: e.target.value === "si" ? true : false
        }))
    }

    useEffect(()=>{
        if(propertySaved) {
            if(typeEdition==="Discontinued") {
              toggleModalAddProperty()
            } 

            toggleTab(activeTab + 1)
            if(!isEdit) {
              setPropertyL(prev => ({
                  ...prev,
                  id: property?.id
              }))
            }
        }
    },[propertySaved]);

    useEffect(()=>{
        return () => {
          dispatch(setProperty(null))
          dispatch(setUploadImageSuccess(false))
        }
    },[]);
  
  return (
    <React.Fragment>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="number">1.</span> {isEdit ? typeEdition === "Discontinued" ? "Dar de Baja" : "Editar propiedad" : "Nueva propiedad"}
                          </NavLink>
                        </NavItem>
                        {typeEdition!=="Discontinued" && (
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="number">2.</span> {isEdit ? "Actualizar imágeness" : "Agregar imágenes"}
                          </NavLink>
                        </NavItem>)}
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          <FormNewProperty isEdit={isEdit} typeEdition={typeEdition} handleCheckChange={handleCheckChange} validation={validation} property={propertyL} />
                        </TabPane>
                        <TabPane tabId={2}>
                          <div>
                            <FormUploadImages handleImagesWithOutOpload={handleImagesWithOutOpload} property={propertyL} />
                          </div>
                        </TabPane>
                      </TabContent>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            typeEdition === 'Discontinued' ? "previous" : activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              typeEdition === 'Discontinued' ? toggleModalAddProperty() : toggleTabBack()
                            }}
                          >
                            Regresar
                          </Link>
                        </li>
                        <li
                          className={activeTab === 3 ? "next disabled" : "next"}
                        >
                          <Link
                            to="#"
                            onClick={() => {
                              if(activeTab===1) {
                                if (typeEdition === 'Discontinued') {
                                  // Tocar el campo para activar la validación
                                  validation.setFieldTouched('justification_discontinuation', true, true);
                                }
                                validation.handleSubmit();
                              } else if (activeTab===2) {
                                props.toggleModalAddProperty()
                              }
                            }}
                          >
                            { typeEdition === 'Discontinued' ? 'Dar de Baja' : activeTab === 2 ? "Listo" : "Guardar y Siguiente"}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>            
          </Row>
    </React.Fragment>
  )
}

export default FormPropertyWizard
